import React, {Component} from 'react';
import VisuallyHidden from '@reach/visually-hidden';
import FocusTrap from 'focus-trap-react';
import {Trans} from '@lingui/macro';
import config from 'config';

import {extractTranslatedLabel} from '../../services/utilities';

import TestItemIcon from '../TestItemIcon';
import RaisedButton from '../RaisedButton';
import Cover from '../Cover';

import s from './TestIntro.css';

function getCover({id, src, color}) {
  return <Cover id={id} src={src} color={color || '#E25240'} />;
}

const letterStyle = {
  fontSize: '30px',
};

class TestIntro extends Component {
  render() {
    const {currentTest, lang, goToDetails} = this.props;
    const cover = currentTest.getIn(['jsonData', 'image']);
    const coverUrl = cover && `${config.testBaseUrl}images/${cover}`;
    const coverColor = currentTest.getIn(['jsonData', 'color'], '#E25240');
    const backgroundStyle = {
      backgroundColor: coverColor,
    };
    const name = extractTranslatedLabel(currentTest, lang, 'name');

    return (
      <FocusTrap>
        <div aria-describedby="test-description" aria-live="assertive">
          <VisuallyHidden>
            <Trans id="test_intro.hidden_label_esc">Clicca esci per tornare alle prove</Trans>
          </VisuallyHidden>
          {getCover({
            id: currentTest.get('id'),
            src: coverUrl,
            color: coverColor,
          })}
          <div className={s.TestDetails}>
            <div style={backgroundStyle} className={s.Background} />
            <TestItemIcon
              letterStyle={letterStyle}
              className={s.ItemAvatar}
              iconLabel={currentTest.get('abbreviation') || name.substr(0, 2).toUpperCase()}
              size={100}
              isActive={true}
            />
            <h1 className={s.Title}>{name}</h1>

            <div className={s.Divider} />
            <div className={s.Content}>
              <p className={s.Description} id="test-description">
                {extractTranslatedLabel(currentTest, lang, 'description')}
              </p>
              <RaisedButton
                className={s.StartButton}
                onClick={goToDetails}
                buttonRef={btn => btn && btn.focus()}
              >
                <Trans id="test_intro.label_btn_entra">Entra</Trans>
              </RaisedButton>
            </div>
          </div>
        </div>
      </FocusTrap>
    );
  }
}

export default TestIntro;
